import { connect } from 'react-redux';

import { Creators as transientActions } from 'Reducers/transient';

import Finish from './view';

export default connect(state => ({ transient: state.transient }), {
  updateTransientProps: transientActions.updateProps
})(Finish);
